import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { Avatar, Button, Chip, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import EmailIcon from 'Components/Icons/EmailIcon';
import EmailPlusIcon from 'Components/Icons/EmailPlusIcon';
import WebFormPlusIcon from 'Components/Icons/WebFormPlusIcon';
import UserIcon from '../../../../../../assets/images/users/Assignees.svg';
import WebForm from './WebForm';
import EmailIntegration from './EmailIntegration.js';
import { menuItems } from '../constant';
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { checkIsPremiumPlan } from 'helper/checkPlan.helper';
import { useQuery } from '@apollo/client';
import { GET_MENUS } from 'schemas/query';
import { getActiveStatus } from 'utils/utils';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '570px',
    bgcolor: '#fff',
    borderRadius: '12px',
    p: 3
};

const cardStyles = {
    flexWrap: 'wrap',
    '.integrate-card': {
        border: '1px solid #DEDEDF',
        backgroundColor: '#ffffff',
        // backgroundColor: '#FAFAFC',
        borderRadius: '12px',
        padding: '16px',
        alignItems: 'flex-start',
        height: 'auto',
        width: '100%',
        maxWidth: '360px',
        transition: '0.3s ease',

        '&:hover': {
            boxShadow: '1px 1px 4px 0px rgba(0, 5, 124, 0.13)'
        },

        '& > .MuiStack-root ': {
            svg: {
                width: '64px',
                height: '64px'
            }
        },

        '.chip': {
            fontWeight: 500,
            color: '#00214D',
            background: 'rgba(0, 33, 77, 0.06)',
            borderRadius: '4px',
            padding: '3px 8px 1px',
            fontSize: '0.875rem',
            lineHeight: '1.143',
            fontWeight: '500',
            height: 'auto',
            '&.enabled': {
                backgroundColor: '#BAF3DB',
                color: '#216E4E'
            },
            '.MuiChip-label': {
                padding: '0'
            }
        }
    }
};

const DiologMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const menuPaths = useMemo(() => menuItems.map((item) => item.path), []);

    const { companyData } = useSelector((params) => params.customization);
    const isAccountPremium = checkIsPremiumPlan(companyData?.subscription?.plan);

    const { data } = useQuery(GET_MENUS);

    const matchPath = useMemo(() => {
        let isMenu = false;
        menuPaths.forEach((item) => {
            if (location.pathname.includes(item)) {
                isMenu = true;
            }
        });
        return isMenu;
    }, [location.pathname]);

    return (
        <Box>
            {matchPath ? (
                <Outlet />
            ) : (
                <Stack gap={3} mt={3}>
                    <Typography variant="body1" color="#00214D" lineHeight="1.42857">
                        Connect integrations to enhance your experience.
                    </Typography>
                    <Stack sx={cardStyles} gap={3} direction="row">
                        {menuItems.map((item) => (
                            <Stack gap={2} className="integrate-card" sx={{ cursor: 'pointer' }} onClick={() => navigate(item.path)}>
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ width: '100%' }}>
                                    {item.icon()}
                                    {isAccountPremium && getActiveStatus(data?.getMenus ?? [], item.type) && (
                                        <Chip className="chip enabled" label="Enabled" />
                                    )}
                                </Stack>

                                <Typography variant="body1" fontSize="1rem" color="#00214D" lineHeight="1.2291" fontWeight="500">
                                    {item.title}
                                </Typography>
                                <Typography variant="body1" color="#00214D" lineHeight="1.40476" sx={{ minHeight: '40px' }}>
                                    {item.description}
                                </Typography>
                                <Chip className="chip" label={item.label} />
                            </Stack>
                        ))}
                    </Stack>
                </Stack>
            )}
        </Box>
    );
};

export default DiologMenu;
